import http from './http'
import Vue from 'vue'

export default {
  install() {
    /**/
    Vue.prototype.$http = http;

    Vue.mixin({
      data() {
        return {
          user: {}
        }
      },
      created() {
        let user = localStorage.getItem('userInfo') || '';
        user && (this.user = JSON.parse(user));
      }
    })
  }
}